import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RevenueShare } from '../invoice.model';

export interface ICellRendererParamsForRevenueShareGridAction extends ICellRendererParams {
    canDelete: (params: ICellRendererParamsForRevenueShareGridAction) => boolean;
    delete: (params: ICellRendererParamsForRevenueShareGridAction) => void;
}

@Component({
    selector: 'fee-allocation-grid-action-cell',
    template:
        `@if (params && params.canDelete(params)) {
  <button type="button" class="ace-btn has-icon btn-primary btn-danger grid-action-button" title="Delete" (click)="onDeleteClicked()">
    <i class="fa fa-trash"></i>
  </button>
}`,
    standalone: false
})
export class RevenueShareGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForRevenueShareGridAction;
    revenueShare: RevenueShare;
    canDelete: boolean;

    agInit(params: ICellRendererParamsForRevenueShareGridAction): void {
        this.params = params;
        this.revenueShare = params.data as RevenueShare;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onDeleteClicked(): void {
        this.params.delete(this.params);
    }
}
